<!--<p-toolbar>
<div class="p-toolbar-group-left">

</div>

<div class="p-toolbar-group-center no-print">
  <app-button icon="mdi mdi-clock-check-outline" styleClass="p-button-outlined p-button-sm p-button-secondary"
  (click)="toggleAllDay()" [label]="dataView"></app-button>
  <app-button label="Print page" icon="mdi mdi-printer"
  styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="printPage()"></app-button>
  <span class="">&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <app-button label="Previous week" icon="mdi mdi-rewind"
  styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="previousWeek()"></app-button>
  <app-button [disabled]="!canGoNextWeek" label="Next week" icon="mdi mdi-fast-forward"
    styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="nextWeek()" iconPos="right">
  </app-button>
  <span class="">&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <app-button label="Previous day" icon="mdi mdi-calendar-arrow-left"
  styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="previous()"></app-button>
  <app-button [disabled]="!canGoNext" label="Next day" icon="mdi mdi-calendar-arrow-right"
  styleClass="p-button-outlined p-button-sm p-button-secondary" (click)="next()" iconPos="right"></app-button>
</div>
</p-toolbar>-->

@if (assets && !isLoading) {
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Floor</th>
        <th>Asset</th>
        @for (h of [00, 01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]; track h) {
          <th tooltipPosition="top" title="Occupancy between {{ h }}:00 and {{ h }}:59">{{ h }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (asset of assets; track asset) {
        <tr>
          <td>{{ asset.floor.t }} <i class="mdi" [class.mdi-clock-outline]="asset.collOfDaysId" [title]="'Restricted hours'"></i></td>
          <td [title]="asset.i + ' ' + asset.title + ' '">{{ asset.t }}</td>
          @for (hour of asset.hours; track hour; let i = $index) {
            <td [class.rating-e]="hour.v !== null && hour.v <= 12" [class.rating-d]="hour.v > 12 && hour.v <= 24" [class.rating-c]="hour.v > 24 && hour.v <= 36" [class.rating-b]="hour.v > 36 && hour.v <= 48" [class.rating-a]="hour.v > 48 && hour.v <= 60" [class.restricted]="asset.collection && (i < asset.collection.dayRow.startHour || i >= asset.collection.dayRow.endHour)">
              @if (hour.v !== null) {
                <span title="{{ hour.v }} mins of occupancy">{{ hour.v ? hour.v : '-' }}</span>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}

@if (noDataExists) {
  <app-info-panel>NO VALUES FOUND</app-info-panel>
}

<div class="pull-right">
  <app-rating-ae [width]="240"></app-rating-ae>
</div>

@if (isLoading) {
  <app-please-wait></app-please-wait>
}
